import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useDeleteProcedureTemplates } from '../../queries/use-delete-procedure-templates';
import { ProcedureTemplate, ProcedureTemplateOverview } from '../../types/procedure';

type ProcedureTemplatesDeleteConfirmProps = {
    templates: (ProcedureTemplateOverview | ProcedureTemplate)[];
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
};

function ProcedureTemplatesDeleteConfirm({ templates, isOpen, onClose, onDelete }: ProcedureTemplatesDeleteConfirmProps): JSX.Element {
    const deleteProcedureTemplatesQuery = useDeleteProcedureTemplates();

    function deleteTemplates(): void {
        const ids = templates.map((template) => {
            return template.id;
        });

        deleteProcedureTemplatesQuery.mutate(
            { ids },
            {
                onSuccess: () => {
                    onDelete();
                    toastNotification('success', `${ids.length} procedure ${ids.length === 1 ? 'template' : 'templates'} deleted!`);
                },
                onError: () => {
                    toastNotification('error', `${ids.length} procedure ${ids.length === 1 ? 'template' : 'templates'} cannot be deleted!`);
                },
            }
        );
    }

    return (
        <Dialog
            title={`Delete Procedure ${templates.length === 1 ? 'Template' : 'Templates'}`}
            description={`Do you want to delete ${
                templates.length > 1 ? `${templates.length} procedure templates` : 'this procedure template'
            }? Any open workpapers using ${
                templates.length > 1 ? 'these procedure templates' : 'this procedure template'
            } will have a copy of the items, but changes can no longer be made to them.`}
            isOpen={isOpen}
            primaryAction="Delete"
            secondaryAction="Cancel"
            type="error"
            onClose={onClose}
            onPrimaryActionClick={deleteTemplates}
            onSecondaryActionClick={onClose}
            isLoading={deleteProcedureTemplatesQuery.isLoading}
        />
    );
}

export default ProcedureTemplatesDeleteConfirm;
